import { render } from "./AddOrganisation.vue?vue&type=template&id=cfd90d7a"
import script from "./AddOrganisation.vue?vue&type=script&lang=js"
export * from "./AddOrganisation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__